import img1 from '../../../assets/img/destination/destination1.png'
import img2 from '../../../assets/img/destination/destination2.png'
import img3 from '../../../assets/img/destination/destination3.png'
import img4 from '../../../assets/img/destination/destination4.png'
import img5 from '../../../assets/img/destination/destination5.png'
import img6 from '../../../assets/img/destination/destination6.png'
import img7 from '../../../assets/img/destination/destination7.png'
import img8 from '../../../assets/img/destination/destination8.png'



export const TopDestinationsData = [
    {
        id:1,
        img: img1,
        heading: "China",
    },
    {
        id:2,
        img: img2,
        heading: "Darjeeling",
    },
    {
        id:3,
        img: img3,
        heading: "Malaysia",
    },
    {
        id:4,
        img: img4,
        heading: "Gangtok",
    },
    {
        id:5,
        img: img5,
        heading: "Thailand",
    },
    {
        id:6,
        img: img6,
        heading: "Australia",
    },
    {
        id:7,
        img: img7,
        heading: "London",
    },
    {
        id:8,
        img: img8,
        heading: "USA",
    },
]